import { Flame } from "lucide-react"

interface Props {
  quantity: number;
  threshold?: number;
  className?: string;
  compact?: boolean;
}

/**
 * "Almost out of stock" flame badge. Only renders when there's inventory
 * still available but the count is below the threshold (default 5). Silent
 * on out-of-stock (that's a separate state) and on healthy stock.
 */
export default function LowStockBadge({ quantity, threshold = 5, className = "", compact = false }: Props) {
  if (quantity <= 0 || quantity >= threshold) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full bg-orange-50 text-orange-700 border border-orange-200 font-semibold ${
        compact ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2 py-1"
      } ${className}`}
      title={`Only ${quantity} left`}
    >
      <Flame className={compact ? "w-3 h-3" : "w-3.5 h-3.5"} strokeWidth={2.5} />
      {compact ? `${quantity} left` : `Only ${quantity} left`}
    </span>
  );
}

/**
 * Sum inventory across all variants of a product to get the "total available"
 * count. Used on cards where no variant is selected yet.
 */
export function totalQuantity(product: { variants?: Array<{ quantity?: number }> }): number {
  if (!product?.variants || product.variants.length === 0) return 0;
  return product.variants.reduce((sum, v) => sum + (v.quantity ?? 0), 0);
}
